// --------------------------------------------------------------
// Created On: 2021-09-30
// Author: Zachary Thomas
//
// Last Modified: 2023-11-21
// Modified By: Zachary Thomas
//
// Copyright 2021 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import styles from "./AccountInfo.module.scss";

// Information about the account that is about to be created.
export default function AccountInfo(props: Props): Component {
  return (
    <div className={styles.text}>
      {props.accountType === "NEW_COMPANY" &&
        "Your are creating a new company account. Once your account is created you can invite other users to join your account."}

      {props.accountType === "JOIN_COMPANY" &&
        "You are requesting to join an existing company account. Your request will be sent to an admin of the account, if your request is approved" +
          " you will receive an email with information on how to login."}
    </div>
  );
}

AccountInfo.propTypes = {
  accountType: PropTypes.string.isRequired,
};

interface Props {
  accountType: "NEW_ACCOUNT" | "NEW_COMPANY" | "JOIN_COMPANY";
}
